import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes } from 'syf-component-library/defaultTheme';
import CLTooltip from 'syf-component-library/ui/atoms/Tooltip';
import { Inset } from 'syf-component-library/ui/spacing';
import { FAR_QUESTION_CIRCLE } from '../../const/iconProps';
import { colors } from '../../defaultTheme';
import { t } from '../../strings/i18n';
const Tooltip = styled(CLTooltip) `
  z-index: 1;
  font-size: ${fontSizes.root}px;
`;
export const Column = styled.div `
  display: flex;
  flex-direction: column;
  height: 60px;

  @media ${query.lessThanSmall} {
    height: 44px;
  }
`;
export const FlexContent = styled.div `
  display: flex;
  justify-content: flex-start;
`;
export const InsetInline = styled(Inset) `
  display: inline-block;
`;
export const CapTooltip = () => (_jsx(Tooltip, Object.assign({ content: t('text.planLengthUpToSixtyMonths'), hasBorder: false, id: "cap-tooltip", isInteractive: false }, { children: _jsx(FontAwesomeIcon, { color: colors.info, icon: FAR_QUESTION_CIRCLE, size: "1x" }) })));
